"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Menu_1 = __importDefault(require("@material-ui/icons/Menu"));
var styles_1 = __importDefault(require("./styles"));
var menu_1 = __importDefault(require("./menu"));
var Top = function (props) {
    var title = props.title, _a = props.menus, menus = _a === void 0 ? [] : _a, isOpen = props.isOpen, onToggle = props.onToggle, className = props.className, CustomComponent = props.CustomComponent, textColor = props.textColor;
    var classes = styles_1["default"]();
    var handleDrawerOpen = function () {
        onToggle && onToggle(isOpen ? isOpen : false);
    };
    return (react_1["default"].createElement(AppBar_1["default"], { position: "absolute", className: clsx_1["default"](classes.appBar, isOpen && classes.appBarShift, className) },
        react_1["default"].createElement(Toolbar_1["default"], { className: classes.toolbar },
            typeof isOpen !== 'undefined' && onToggle && (react_1["default"].createElement(IconButton_1["default"], { edge: "start", "aria-label": "open drawer", onClick: handleDrawerOpen, style: textColor ? { color: textColor } : undefined, className: classes.iconButton },
                react_1["default"].createElement(Menu_1["default"], null))),
            react_1["default"].createElement(Typography_1["default"], { component: "h1", variant: "h6", noWrap: true, className: classes.title, style: textColor ? { color: textColor } : undefined }, title),
            CustomComponent && react_1["default"].createElement(CustomComponent, null),
            react_1["default"].createElement(menu_1["default"], { list: menus, textColor: textColor }))));
};
exports["default"] = Top;
